/**
 * Curated list of IANA timezone identifiers offered by the publisher-config
 * timezone dropdown.
 *
 * PROVENANCE
 * These are the major advertiser-account timezones, sourced from Amazon DSP's
 * verified advertiser-account timezone list (43 entries, from
 * `GlobalRegistrationService/TimezoneHelper.java`), plus `America/Phoenix`
 * (Arizona / no-DST Mountain — a legitimate US advertiser timezone DSP omits).
 * Retrieved 2026-07-27.
 *
 * VALIDATION
 * All 44 entries are accepted by `new Intl.DateTimeFormat({ timeZone })`. `EET`
 * is a valid POSIX alias that canonicalizes to `Europe/Athens`.
 *
 * INTERNAL-ONLY VALUE
 * The stored timezone is used only inside Leela — for sports asset schedule
 * computation and display. It is NOT transmitted to the downstream ad platform
 * (Leela does asset sync, not campaign creation on Meta/DSP/TikTok), so it need
 * not match any specific ad platform's accepted-timezone enumeration; a curated
 * list of the timezones a publisher account would realistically use is enough.
 *
 * MAINTENANCE
 * To add a timezone, append its IANA identifier and confirm that
 * `Intl.DateTimeFormat` accepts it.
 */
export const PUBLISHER_TIMEZONES: readonly string[] = [
  'America/Anchorage',
  'America/Caracas',
  'America/Chicago',
  'America/Denver',
  'America/Halifax',
  'America/Los_Angeles',
  'America/Mexico_City',
  'America/New_York',
  'America/Phoenix',
  'America/Sao_Paulo',
  'America/St_Johns',
  'Asia/Almaty',
  'Asia/Baghdad',
  'Asia/Bangkok',
  'Asia/Dubai',
  'Asia/Hong_Kong',
  'Asia/Kabul',
  'Asia/Kathmandu',
  'Asia/Kolkata',
  'Asia/Magadan',
  'Asia/Riyadh',
  'Asia/Shanghai',
  'Asia/Singapore',
  'Asia/Tehran',
  'Asia/Tokyo',
  'Asia/Yekaterinburg',
  'Asia/Yerevan',
  'Atlantic/Azores',
  'Atlantic/South_Georgia',
  'Australia/Brisbane',
  'Australia/Darwin',
  'Australia/Sydney',
  'EET',
  'Europe/Amsterdam',
  'Europe/Istanbul',
  'Europe/London',
  'Europe/Paris',
  'Europe/Stockholm',
  'Indian/Cocos',
  'Pacific/Auckland',
  'Pacific/Fiji',
  'Pacific/Honolulu',
  'Pacific/Kwajalein',
  'Pacific/Midway',
];
